import React from 'react';
import { Icon as IconBaseComponent, IconProps } from '../../Icon';
import { useCustomComponent } from '@/hooks';

export interface ToggleViewIconProps {
  name: IconProps['name'];
  color?: string;
}

const IconComponent: React.FC<ToggleViewIconProps> = ({ name, color }) => {
  return <IconBaseComponent name={name} color={color ?? 'currentColor'} />;
};

export const Icon: React.FC<ToggleViewIconProps> = (
  props: ToggleViewIconProps
) => {
  const Component = useCustomComponent({
    componentName: 'ToggleViewIcon',
    Component: IconComponent,
  });

  return <Component {...props} />;
};
